import { addAttachment, detachAttachment, fetchNoteAttachmentBreadcrumbs, removeAttachment, updatedAttachment } from "../../reducers/noteAttachmentsSlice"
import { fetchUniqueCounts, fetchUniqueCountsForEachPath } from "../../reducers/workspaceNoteSlice"
import {openPrimaryWorkspace, openSecondaryWorkspace } from "../../reducers/workspaceSlice"
import { getCurrentUserId } from "./notesSocketMiddleware"

export const noteAttachmentMiddleware = (socket) => {
	return (storeAPI) => {
		socket.on("NEW_NOTE_ATTACHMENT", (payload) => {
			const {userId, note, attachment} = payload
			const {workspaceId} = note
			const state = storeAPI.getState()
			const currentUserId = getCurrentUserId(storeAPI)
			if (currentUserId != userId) {
				// first, update unique count for the incoming attachment note
				storeAPI.dispatch(fetchUniqueCounts({id: note.id, workspaceId}))
				// next, check if their is a tab open to push data into
				if (state.noteAttachmentsSlice.byWorkspace[workspaceId].noteAttachmentMap[note.id]) {
					storeAPI.dispatch(addAttachment({attachment, workspaceId}))
				}
				// check if breadcrumbs exist, if they do, update them
				if (state.noteAttachmentsSlice.byWorkspace[workspaceId].breadcrumbs[attachment.id]) {
					storeAPI.dispatch(fetchNoteAttachmentBreadcrumbs({attachment, workspaceId}))
				}
			}
		})

		socket.on("UPDATE_NOTE_ATTACHMENT", (payload) => {
			const {userId, attachment, workspaceId} = payload
			const currentUserId = getCurrentUserId(storeAPI)
			if (currentUserId != userId) {
				// find all instances of the attachment and update
				storeAPI.dispatch(updatedAttachment({attachment, workspaceId}))
			}

		})
		
		socket.on("DELETE_NOTE_ATTACHMENT", (payload) => {
			const {paths, userId, deletedAttachment, workspaceId} = payload
			const currentUserId = getCurrentUserId(storeAPI)
			if (currentUserId != userId) {
				storeAPI.dispatch(fetchUniqueCountsForEachPath({paths, workspaceId}))
				storeAPI.dispatch(removeAttachment({deletedAttachment}))
			}
		})
		socket.on("DETACH_NOTE_ATTACHMENT", (payload) => {
			const {note, userId, attachment} = payload
			const {workspaceId} = note
			const currentUserId = getCurrentUserId(storeAPI)
			if (currentUserId != userId) {
				storeAPI.dispatch(fetchUniqueCounts({id: note.id, workspaceId}))
				storeAPI.dispatch(fetchNoteAttachmentBreadcrumbs({attachment, force: true, workspaceId}))
				storeAPI.dispatch(detachAttachment({note, attachment}))
			}
		})
		return next => async action => {
			if (
				action.type === openPrimaryWorkspace.fulfilled.type ||
				action.type === openSecondaryWorkspace.fulfilled.type
			) {
				const workspaceId = action.payload.workspace.id
				socket.emit("SUBSCRIBE_TO_NOTE_ATTACHMENTS", {workspaceId})
			}
			return next(action)
		}
	}
}